export default "__VITE_PUBLIC_ASSET__091c19c5__"